import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'
import axios from '@/plugins/axios'
import get from 'lodash/get'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'keycloak',
    ...crudState(),
    allIPDesk: [],
    allIPPortal: [],
    identityProvider: {}
  }),
  getters: {
    ...crudGetters,
    allIPDesk: state => state.allIPDesk,
    allIPPortal: state => state.allIPPortal,
    identityProvider: state => state.identityProvider
  },
  mutations: {
    ...crudMutations,
    setAllIPDesk (state, value) {
      state.allIPDesk = value
    },
    setAllIPPortal (state, value) {
      state.allIPPortal = value
    },
    setIdentityProvider (state, value) {
      state.identityProvider = value
    }
  },
  actions: {
    ...crudActions,
    async getAllIP ({ commit, state }, type) {
      commit('setLoading', 1, { root: true })
      try {
        const url = `${state.endpoint}/getkcip`
        const response = await axios.get(url, {params: {type}})
        const message = get(response, 'data.message', {})
        const data = get(response, 'data.data', {})
        commit('setLoading', -1, { root: true })
        if(type === 'portal') {
          commit('setAllIPPortal', data)
        } else {
          commit('setAllIPDesk', data)
        }
        data.message = message
        return data
      } catch (e) {
        console.error('Error:', e)
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    },
    async getIPById ({ commit, state }, {providerId, type}) {
      async function decrypt (encryptedData, secretKey) {
        const key = new TextEncoder().encode(secretKey)
        const encryptedDataBytes = Uint8Array.from(atob(encryptedData), c => c.charCodeAt(0))
        const iv = encryptedDataBytes.slice(0, 12)
        const encryptedBytes = encryptedDataBytes.slice(12)
        const cryptoKey = await crypto.subtle.importKey('raw', key, { name: 'AES-GCM' }, false, ['decrypt'])
        const decryptedArrayBuffer = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, cryptoKey, encryptedBytes)
        const decryptedData = new TextDecoder().decode(decryptedArrayBuffer)
        return decryptedData
      }
      async function decryptData (data, skey) {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const value = data[key]
            if (typeof value === 'object' && value !== null) {
              await decryptData(value, skey)
            } else {
              try {
                const decryptedValue = await decrypt(value, skey)
                data[key] = decryptedValue
              } catch (error) {
                console.error(`Error decrypting key ${key}:`, error)
              }
            }
          }
        }
      }
      commit('setLoading', 1, { root: true })
      try {
        const url = `${state.endpoint}/getkcipbyid`
        const response = await axios.get(url, { params: { providerId, type } })
        const message = get(response, 'data.message', {})
        const data = get(response, 'data.data', {})
        const key = process.env.VUE_APP_KC
        decryptData(data, key)
        commit('setLoading', -1, { root: true })
        commit('setIdentityProvider', data)
        return data
      } catch (e) {
        console.error('Error:', e)
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    },
    async destroyIP ({ commit, state }, {id, type}) {
      commit('setLoading', 1, { root: true })
      try {
        const url = `${state.endpoint}/deletekcip`
        const response = await axios.delete(url, { params: { providerId: id, type } })
        const message = get(response, 'data.message', {})
        const data = get(response, 'data.data', {})
        commit('setLoading', -1, { root: true })
        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    },
    async createIP ({ commit, state }, {object, type}) {
      async function encrypt (data, secretKey) {
        const key = new TextEncoder().encode(secretKey)
        const iv = crypto.getRandomValues(new Uint8Array(12)) // Crear un IV aleatorio
        const cryptoKey = await crypto.subtle.importKey('raw', key, { name: 'AES-GCM' }, false, ['encrypt'])
        const encodedData = new TextEncoder().encode(data)
        const encryptedArrayBuffer = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, cryptoKey, encodedData)

        const encryptedBytes = new Uint8Array(encryptedArrayBuffer)
        const encryptedDataWithIv = new Uint8Array(iv.length + encryptedBytes.length)
        encryptedDataWithIv.set(iv)
        encryptedDataWithIv.set(encryptedBytes, iv.length)

        return btoa(String.fromCharCode.apply(null, encryptedDataWithIv))
      }
      async function encryptData (data, secretKey) {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const value = data[key]
            if (typeof value === 'object' && value !== null) {
              await encryptData(value, secretKey)
            } else {
              try {
                const encryptedValue = await encrypt(value, secretKey)
                data[key] = encryptedValue
              } catch (error) {
                console.error(`Error encrypting key ${key}:`, error)
              }
            }
          }
        }
      }
      const key = process.env.VUE_APP_KC
      await encryptData(object, key)
      commit('setLoading', 1, { root: true })
      try {
        const url = `${state.endpoint}/identityproviderkc`
        const response = await axios.post(url, object, {params: {type}})
        const message = get(response, 'data.message', {})
        const data = get(response, 'data.data', {})
        commit('setLoading', -1, { root: true })
        data.message = message
        return Promise.resolve(data)
      } catch (e) {
        console.error('Error:', e)
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    }
  }
}
